import { render, staticRenderFns } from "./SelectGenreDialog.vue?vue&type=template&id=5e0c2e79&scoped=true"
import script from "./SelectGenreDialog.vue?vue&type=script&lang=js"
export * from "./SelectGenreDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectGenreDialog.vue?vue&type=style&index=0&id=5e0c2e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c2e79",
  null
  
)

export default component.exports